<template>
  <div class="user-mini">
    <p v-if="data == undefined || data == null">{{$t('components.userMini.userNotFound')}}</p>
    <p
      style="margin: 0"
      v-if="data != undefined && data != null"
    >{{data.firstName}} {{data.lastName}}</p>
  </div>
</template>

<script>
export default {
  name: "UserMini",
  props: ["data"]
};
</script>


// WEBPACK FOOTER //
// src/components/UserMini.vue